import { Grid, makeStyles } from "@material-ui/core";

import { Icon } from "../base";
import { COLORS } from "../../theme/colors";
import { HorizontalTabs } from "../horizontalTabs";
import RightArrowImg from "../../assets/images/icons/rightArrow.svg";
import LeftArrowImg from "../../assets/images/icons/leftArrow.svg";

const useStyles = makeStyles((theme) => ({
  arrowGroup: {
    borderBottom: `solid 4px ${COLORS.americanSilver}`,
    height: "100%",
    paddingTop: theme.spacing(0.5),
    paddingRight: theme.spacing(2.25),
    columnGap: theme.spacing(2.75),
  },
  tabContainer: {
    borderBottom: `solid 4px ${COLORS.americanSilver}`,
    width: "100vw",
  },
}));

export const HorizontalArrowTabs = ({ tab, setTab, tabNames, variant }) => {
  const classes = useStyles();

  const next = () => {
    if (tab < tabNames.length - 1) {
      setTab(tab + 1);
    }
  };

  const back = () => {
    if (tab > 0) {
      setTab(tab - 1);
    }
  };

  return (
    <Grid container justifyContent="space-between">
      <Grid item xs={9}>
        <HorizontalTabs
          tab={tab}
          setTab={setTab}
          tabNames={tabNames}
          variant={variant}
          flexContainer={classes.tabContainer}
        />
      </Grid>
      <Grid item xs={3}>
        <Grid
          className={classes.arrowGroup}
          container
          alignItems="center"
          justifyContent="flex-end"
        >
          <Icon src={LeftArrowImg} hoverable onClick={back} />
          <Icon src={RightArrowImg} hoverable onClick={next} />
        </Grid>
      </Grid>
    </Grid>
  );
};
